/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import { DeviceState } from './deviceState';
import { DeviceStateGroup } from './deviceStateGroup';

export const DevicesExportRequestStateItem = {...DeviceStateGroup,...DeviceState,} as const